import apiClient from "./apiClient";
import { decodeBase64Json } from "../utils/decodeBase64Json";
export const getCustomerByIdd = async () => {
  try {
    const response = await apiClient.post(
      "/DS/admin_center/get_partition_info.zjs",
    );
    return response.data;
  } catch (error) {
    console.error("Error in getCartableUser service:", error.response || error);
    throw error;
  }
};


export const updateUserProfile = async (payload) => {
  try {
    const response = await apiClient.post(
      "/DS/admin_center/define_admin_company.zjs",
      {
        full_name: payload.fullName,
        lt_country_id: payload.countryId,
        national_id: payload.nationalId,
        economic_code: payload.economicCode,
        primary_bank_account: payload.bankAccount,
        company_name:payload.company,
        company_abv: payload.companyAbbriviation,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error in updateUserProfile:", error.response || error);
    throw error;
  }
};

export const getCustomerAddress = async () => {
  try {
    const res = await apiClient.post(
      "/DS/admin_center/get_user_address.zjs"
    );
    return res.data;
  } catch (err) {
    console.error("getCustomerAddress failed:", err.response || err);
    throw err;
  }
};


export const getCustomerContact = async () => {
  try {
    const res = await apiClient.post(
      "/DS/admin_center/get_user_contact.zjs"
    );
    return res.data;
  } catch (err) {
    console.error("getCustomerContact failed:", err.response || err);
    throw err;
  }
};

export const saveCustomerAddress = async (payload) => {
  try {
    const res = await apiClient.post(
      "/DS/admin_center/create_user_address.zjs",
      payload
    );
    return res.data;
  } catch (err) {
    console.error("saveCustomerAddress failed:", err.response || err);
    throw err;
  }
};


export const saveCustomerContact = async (payload) => {
  try {
    const res = await apiClient.post(
      "/DS/admin_center/create_user_contact.zjs",
      payload
    );
    return res.data;
  } catch (err) {
    console.error("saveCustomerContact failed:", err.response || err);
    throw err;
  }
};




export const getCustomerUsers = async () => {
  try {
    const res = await apiClient.post(
      "/DS/customer/get_customer_users.zjs"
    );
    return res.data;
  } catch (err) {
    console.error("getCustomerUsers failed:", err.response || err);
    throw err;
  }
};
export const getCustomerUserRoles = async (Method) => {
  try {
    const res = await apiClient.post(
      "/DS/customer/get_customer_user_roles.zjs", {
      method: Method //PERMISSION || ROLE
    }
    );
    return res.data;
  } catch (err) {
    console.error("getCustomerUserRoles failed:", err.response || err);
    throw err;
  }
};
export const createCustomerUser = async (payload) => {
  try {
    const res = await apiClient.post(
      "/DS/customer/customer_user_signup.zjs",
      {
        full_name: payload.full_name,
        user_name: payload.user_name,
        password: payload.password,
        customer_user_role_id: payload.role_id
      }
    );

    return res.data;
  } catch (err) {
    console.error("createCustomerUser failed:", err.response || err);
    throw err;
  }
};
export const updateCustomerUser = async (payload) => {
  try {
    const res = await apiClient.post(
      "/DS/customer/customer_user_signup.zjs",
      {
        customer_user_id: payload.user_id,
        full_name: payload.full_name,
        user_name: payload.user_name,
        customer_user_role_id: payload.role_id
      }
    );

    return res.data;
  } catch (err) {
    console.error("updateCustomerUser failed:", err.response || err);
    throw err;
  }
};

export const getCustomerUserPermissions = async (roleId) => {
  try {
    const res = await apiClient.post(
      "/DS/customer/get_customer_user_permissions.zjs",
      {
        cp_customer_user_role_definition_id: roleId,
      }
    );

    return res.data;
  } catch (err) {
    console.error(
      "getCustomerUserPermissions failed:",
      err.response || err
    );
    throw err;
  }
};

export const updateCustomerUserPermission = async (payload) => {
  try {
    const res = await apiClient.post(
      "/DS/customer/customer_role_and_permission_update.zjs",
      payload
    );

    return res.data;
  } catch (err) {
    console.error(
      "updateCustomerUserPermission failed:",
      err.response || err
    );
    throw err;
  }
};
export const getCustomerMessages = async (pageNumber, pageSize) => {
  try {
    const res = await apiClient.post(
      "/DS/customer/get_customer_messages.zjs",
      {
        page_number: pageNumber,
        page_size: pageSize,
      }
    );
    const base64 = res?.data?.[0]?.ResultBase64;

    const decoded = decodeBase64Json(base64);
    // console.log(decoded);

    return decoded;
  } catch (err) {
    console.error("getCustomerMessages failed:", err.response || err);
    throw err;
  }
};
